import { Dialog } from "@mui/material";

import { Item } from "views/Items/Item/Item";

import { EDIT_MODAL_STYLES } from "editConfig";

const sx = {
  "& .MuiDialog-paper": { minHeight: "93vh", maxHeight: "93vh" },
};

export function QuickAddItem(props) {
  const { open, onAdd, onClose, initialNameValue } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={sx}
      data-testing="addNewItem"
      {...EDIT_MODAL_STYLES}
    >
      <Item
        key={open}
        name={initialNameValue}
        onAdd={onAdd}
        onClose={onClose}
        fromForm={true}
      />
    </Dialog>
  );
}
